import { render, staticRenderFns } from "./StartupInfo.vue?vue&type=template&id=c47696a6&scoped=true&"
import script from "./StartupInfo.vue?vue&type=script&setup=true&lang=js&"
export * from "./StartupInfo.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47696a6",
  null
  
)

export default component.exports